import { render, staticRenderFns } from "./DualListBox.vue?vue&type=template&id=6dbd7b65&scoped=true"
import script from "./DualListBox.vue?vue&type=script&lang=ts"
export * from "./DualListBox.vue?vue&type=script&lang=ts"
import style0 from "./DualListBox.vue?vue&type=style&index=0&id=6dbd7b65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbd7b65",
  null
  
)

export default component.exports